import { handleCopyDrawer } from '@terminal/views/insight-feed/utils/handleCopyDrawer';
import { type RefObject, useState } from 'react';

interface UseInsightCopyArgs {
  contentWrapperRef?: RefObject<HTMLDivElement | null>;
  expandAccordions?: (expand: boolean) => void;
}

export const useInsightCopy = ({
  contentWrapperRef,
  expandAccordions,
}: UseInsightCopyArgs) => {
  const [isCopying, setIsCopying] = useState(false);

  const handleCopyInsight = async () => {
    if (!contentWrapperRef?.current || isCopying) {
      return;
    }

    setIsCopying(true);
    try {
      await handleCopyDrawer({
        contentToCopy: contentWrapperRef.current,
        expandAccordions,
      });
    } finally {
      setIsCopying(false);
    }
  };

  return { isCopying, handleCopyInsight };
};
